module.exports = __webpack_public_path__ + "static/bkg-home-products-group-af0673dcd1b38b2a89981dd97226f79b.jpg";